import React, { Component } from "react";
import {
	Box,
  Typography,
} from "@mui/material";
import {
  withStyles
} from "@mui/styles";
import {
  HeadElement,
  InformationUserLevel,
  HistoryEffectiveness
} from "./components";
import {
  VisibleContent
} from "../../../components";
import agent from "../../../agent/agent";
import moment from "moment";
import "moment/locale/ru";

class Statistics extends Component {
	constructor(props) {
		super(props);

		this.state = {
      completed: null,
      currentStat: null,
      currentMountYear: "",
      historyEffectiveness: [],
			isLoading: true,
		};
	}

	componentDidMount = async () => {
		await this.getStatistics();
	}

	getStatistics = async () => {
		this.setState({ isLoading: true });
    const mechanicId = this.props?.user?.id;
    const dateYear = moment().format('YYYY');
    const dateMonth = moment().format('MM');
    const response = await agent.get(`/mechanic-statistics/${ mechanicId }/hours?year=${ dateYear }&month=${ dateMonth }`)
      .then((res) => res?.data)
      .catch((err) => {
        return {error: err?.response || true}
      })

    const monthsAmount = moment().month() + 1;
    const calcEfficiency = (item) => {
      const actual = Number(item?.actual) || 0;
      const norm = Number(item?.norm) || 0;
      if (actual <= 0 || norm <= 0) {
        return 0;
      }
      const ratio = actual / norm;
      return Math.floor(ratio * 100) / 100;
    }
    const itemHistory = await agent.get(`/mechanic-statistics/${ mechanicId }/hours/history?months=${ monthsAmount }`)
      .then((res) => {
        const _items = res.data?.statistics || [];
        return _items.map((item) => ({
          ...item,
          efficiency: calcEfficiency(item),
        }));
      }).catch(() => []);

    const targetMoment = moment().subtract(1, 'month');
    const formatMonthLabel = (dateString) => {
      const mDate = dateString ? moment(dateString, "YYYY-MM") : moment();
      const label = mDate.locale("ru").format("MMMM YY");
      return label.charAt(0).toUpperCase() + label.slice(1);
    }
    const sumBy = (items, key) => items.reduce((acc, item) => acc + (Number(item?.[key]) || 0), 0);
    const getCarsValue = (item) => Number(item?.cars_count ?? item?.count ?? item?.vehicles ?? 0);
    const sumCars = (items) => items.reduce((acc, item) => acc + getCarsValue(item), 0);
    const historyEffectiveness = (() => {
      if (!itemHistory.length) {
        return [];
      }

      const validItems = itemHistory.filter((item) => {
        const actual = Number(item?.actual) || 0;
        const norm = Number(item?.norm) || 0;
        return actual > 0 && norm > 0;
      });

      const targetMonthKey = targetMoment.format("YYYY-MM");
      const currentMonthItem = itemHistory.find((item) => item?.month === targetMonthKey) || itemHistory[0];
      const currentMonthLabel = formatMonthLabel(currentMonthItem?.month || targetMonthKey) || itemHistory[0];
      const currentYearLabel = `${ targetMoment.format("YYYY") } год`;

      const sumActual = sumBy(validItems, "actual");
      const sumNorm = sumBy(validItems, "norm");

      const currentMonthActual = Number(currentMonthItem?.actual) || 0;
      const totalCars = sumCars(itemHistory);
      const monthCars = getCarsValue(currentMonthItem);

      return [
        {
          title: "Н/ч",
          data: [
            { label: currentMonthLabel, value: `${ Math.round(currentMonthActual) } н/ч` },
            { label: currentYearLabel, value: `${ Math.round(sumActual) } н/ч` },
          ],
        },
        {
          title: "Эффективность",
          data: [
            { label: currentMonthLabel, value: (calcEfficiency(currentMonthItem) || 0).toFixed(2) },
            { label: currentYearLabel, value: (calcEfficiency({ norm: sumNorm, actual: sumActual }) || 0).toFixed(2) },
          ],
        },
        {
          title: "Количество авто",
          data: [
            { label: currentMonthLabel, value: `${ monthCars } шт.` },
            { label: currentYearLabel, value: `${ totalCars } шт.` },
          ],
        },
      ];
    })();

    const monthYear = moment().format('MMMM YYYY');
    const currentMountYear = monthYear.charAt(0).toUpperCase() + monthYear.slice(1) + ' год';

		this.setState({
      isLoading: false,
      currentStat: response,
      completed: response?.completed,
      currentMountYear: currentMountYear,
      historyEffectiveness: historyEffectiveness
    });
	}

	render() {
		const {
			classes
		} = this.props;
		const {
      completed,
      isLoading,
      currentStat,
      currentMountYear,
      historyEffectiveness,
		} = this.state;

		return (
			<Box className={classes.root}>
        <HeadElement/>
        <VisibleContent visible={!isLoading}>
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>{ currentMountYear }</Typography>
            <InformationUserLevel currentStat={currentStat} completed={completed}/>
          </Box>
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>История эффективности</Typography>
            <HistoryEffectiveness sections={historyEffectiveness}/>
          </Box>
        </VisibleContent>
			</Box>
		);
	}
}

const styles = {
	root: {
    padding: "20px 32px",
    background: "#fff",
    borderRadius: "20px",
    boxSizing: "border-box",

    "@media (max-width: 859px)": {
      padding: "12px 20px",
      borderRadius: "12px",
    }
	},

  section: {
    marginTop: "30px"
  },
  sectionTitle: {
    marginBottom: "20px",

    fontSize: 16,
    color: "#434146",
    fontWeight: "700",
    lineHeight: "18px",
    letterSpacing: "0.03em"
  },
}
Statistics = withStyles(styles)(Statistics)

export default Statistics;
